import Geo from 'models/Geo';

export default class City {

	constructor(attr, clientGeo, copy, useEnglishCopy) {
		this.name = useEnglishCopy && attr.city_en ? attr.city_en : attr.city;
		this.nameEn = attr.city_en || attr.city;
		this.localName = attr.city;
		this.state = attr.state;

		this.screeningsCount = +attr.count;

		this.geo = new Geo({
			lat:         attr.lat,
			lon:         attr.lon,
			countryCode: attr.country || clientGeo.countryCode,
			city:        attr.city
		});

		this.distanceUnit = copy['$' + (attr.country || '').toUpperCase() + '_DISTANCE_UNIT'] || copy.$DISTANCE_UNIT;
		this.distanceKm = this.geo.distanceFrom(clientGeo);
		// To avoid having to do the expensive calculations twice on all cities, just multiply the result
		this.distance = this.distanceUnit.toLowerCase() === 'mi' ? Geo.kmToMiles(this.distanceKm) : this.distanceKm;
		// this.distance = this.geo.distanceFrom(clientGeo, this.distanceUnit);
	}

	merge(attr, clientGeo) {
		const add = +attr.count;
		const newCount = this.screeningsCount + add;

		// Mean position
		// const newLat = (this.geo.lat * this.screeningsCount + attr.lat * add) / newCount;
		// const newLon = (this.geo.lon * this.screeningsCount + attr.lon * add) / newCount;
		// this.geo.update({ lat: newLat, lon: newLon });
		//
		// this.distanceKm = this.geo.distanceFrom(clientGeo);
		// this.distance = Geo.kmToMiles(this.distanceKm);

		this.screeningsCount = newCount;
	}

}
